module.exports = __webpack_public_path__ + "static/media/tools.9c8b61e1.jpg";